import { useAuth } from './index';

export const useHasExternals = () => {
  const { isSuper, permissions } = useAuth();
  return isSuper || permissions.some(p => !p.includes('outreach'));
};
